import { Image } from "@chakra-ui/react"
export const GoogleIcon=()=>{
return (
  <>
    <Image width="20px" src="https://pro.trackingtime.co/img/login/google-logo.png" />
  </>
);
}
export const AppleIcon=()=>{
    return (
      <>
        <Image
          width="20px"
          src="https://pro.trackingtime.co/img/login/apple-logo.png"
        />
      </>
    );
}
export const MicrodoftIcon=()=>{
    return (
      <>
        <Image
          width="20px"
          src="https://pro.trackingtime.co/img/login/microsoft-logo.png"
        />
      </>
    );
}
export const Dropdownicon=()=>{
    return (
      <>
        <Image
          style={{
            width: "17px",
            height: "11px",
            marginTop: "2px",
         marginRight:"2px",
            cursor: "pointer",
            background: "white",
          }}
          src="https://trackingtime.co/wp-content/themes/trackingtime-v4/img/home/arrow-icon.png"
        />
      </>
    );
}